import { Icon, IconPath } from '@nespresso-design-system/components'
import styles from './ExpandableButton.module.scss'
import React from 'react'
import { CTA } from '@commons/drupal.types'

// TODO: This component should ideally be inside DS repo, and not as a standalone component in here.

type ExpandableButtonProps = CTA & {
    onClick?: (e?) => void
    children?: React.ReactNode
}

const ExpandableButton = (props: ExpandableButtonProps) => {
    const {
        aria_label_before = '',
        link = '',
        label = '',
        variant = 'primary',
        config = {
            icon: '24/symbol/chevron-right',
            iconPosition: 'leading'
        },
        icon,
        onClick,
        children
    } = props

    const { iconPosition } = config

    const content = <ButtonText>{children ?? label}</ButtonText>

    const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
        if (link) {
            window.location.href = link
        } else {
            e.preventDefault()
        }
        onClick?.()
    }

    return (
        <button
            onClick={handleClick}
            className={`${styles.expandableButton} ${styles['expandableButton__variant--' + variant]} ${styles['expandableButton__icon--' + iconPosition]}`}
            aria-label={aria_label_before}>
            {iconPosition === 'leading' && content}

            <div className={styles.expandableButtonIcon}>
                <Icon
                    icon={(icon as IconPath) || '24/symbol/chevron-right'}
                    method="mask"
                />
            </div>

            {iconPosition === 'trailing' && content}
        </button>
    )
}

const ButtonText = ({
    label,
    children
}: {
    label?: string
    children?: React.ReactNode
}) => {
    return (
        <div className={styles.expandableButtonText}>{children ?? label}</div>
    )
}

export default ExpandableButton
